import classNames from 'classnames';

import { Button, CTCTDekstopLogo, CTCTMobileLogo, CTCTMWebVariantLogo, XIcon } from '@ctct/payflow-ui';

import './payflow-top-bar.scss';

interface PayflowTopBarProps {
  logoLink?: string;
  exitLink?: string;
  onLogoClick?: () => void;
  onExitClick?: () => void;
  // when nonInteractive = true, the logo will not be clickable and exit button will not be rendered
  nonInteractive?: boolean;
  isMWebVariantEnabled?: boolean;
  // when isDesktopExitHidden = true, the exit button is not rendered on desktop (mobile is unaffected).
  // Used by the standalone Checkout pages where we want to keep users in the payment step.
  isDesktopExitHidden?: boolean;
  closeLabel?: string;
}

const renderExitButton = (onExitClick?: () => void, exitLink?: string, ariaLabel = 'Close') => {
  return onExitClick ? (
    <Button onClick={onExitClick} variant="text" aria-label={ariaLabel}>
      <XIcon className="x-icon" />
    </Button>
  ) : (
    <a href={exitLink} aria-label={ariaLabel}>
      <XIcon className="x-icon" />
    </a>
  );
};

const renderLogoButton = (
  LogoComponent: React.ComponentType,
  onLogoClick?: () => void,
  logoLink?: string,
  disabled?: boolean
) => {
  if (disabled) {
    return <LogoComponent />;
  }

  return onLogoClick ? (
    <Button onClick={onLogoClick} variant="text">
      <LogoComponent />
    </Button>
  ) : (
    <a href={logoLink}>
      <LogoComponent />
    </a>
  );
};

export const PayflowTopBar = ({
  logoLink = '/pages/dashboard/home',
  exitLink = '/pages/dashboard/home',
  onLogoClick,
  onExitClick,
  nonInteractive = false,
  isMWebVariantEnabled = false,
  isDesktopExitHidden = false,
  closeLabel = 'Close',
}: PayflowTopBarProps) => {
  if (isMWebVariantEnabled) {
    return (
      <div className={classNames('payflow-presentation', 'payflow-payflow-top-bar', 'with-mweb-variant')}>
        <div className="mobile-only">
          {renderLogoButton(CTCTMWebVariantLogo, onLogoClick, logoLink, nonInteractive)}
          {!nonInteractive && renderExitButton(onExitClick, exitLink, closeLabel)}
        </div>
      </div>
    );
  }

  return (
    <div className={classNames('payflow-presentation payflow-payflow-top-bar')}>
      <div className="desktop-only">
        {renderLogoButton(CTCTDekstopLogo, onLogoClick, logoLink, nonInteractive)}
        {!nonInteractive && !isDesktopExitHidden && renderExitButton(onExitClick, exitLink, closeLabel)}
      </div>
      <div className="mobile-only">
        {renderLogoButton(CTCTMobileLogo, onLogoClick, logoLink, nonInteractive)}
        {!nonInteractive && renderExitButton(onExitClick, exitLink, closeLabel)}
      </div>
    </div>
  );
};
